import React from 'react';
import { Link } from 'react-router-dom';

const RestApiInfo = ({ projectId, version }) => {
  return (
    <div className="row">
      <div className="col-12">
        <ul>
          {/* 
          // TODO: Ali -> Remove in cleanup.
          */}
          {/* <li>To access data from browser session {`{{current_session.key}}`}</li> */}
          {/* <li>To access data from browser session form data {`{{form_data_session.key}}`}</li> */}
          <li>
            To access data from browser session storage{' '}
            {`{{SESSION_STORAGE.<replace_with_key_full_path>}}`}
          </li>
          <li>
            To access data from browser local storage{' '}
            {`{{LOCAL_STORAGE.<replace_with_key_full_path>}}`}
          </li>
          <li>To access data from browser cookies {`{{COOKIES.<replace_with_key_full_path>}}`}</li>
          <li>
            To access data from browser indexed db {`{{INDEXED_DB.<replace_with_key_full_path>}}`}
          </li>
          <li>
            To access current logged in user's data use{' '}
            {`{{current_user.<replace_with_key_full_path>}}`}
          </li>
          <li>
            To access data from environment based variables{' '}
            {`{{environment_variable.<replace_with_key_full_path>}}`}&nbsp;
            <u>
              <Link to={`/2.0/app-setting/${version}/v/${projectId}`} style={{ color: '#1F2041' }}>
                Create Environment Variable{' '}
                <i className="webconnect webconnect-box-arrow-up-right"></i>
              </Link>
            </u>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RestApiInfo;
